module.exports = __webpack_public_path__ + "static/media/paper-matching-v2.e62bb889.svg";